import React from "react";
import Header from "../Structure/Header";
import Sidebar from "../Structure/Sidebar";
import PageHeader from "./PageHeader";
import PrintLetterhead from "./PrintLetterhead";
import useOrgProfile from "../../util/accounting/orgProfile";

/**
 * The shell every accounting page sits in.
 *
 * It keeps the page header that the accounting pages were written against —
 * title, breadcrumb, description and the action buttons top-right — but wraps
 * them in *this* system's chrome rather than the one they came from. That is
 * what makes accounting feel like a room inside the building instead of a
 * different building: the same header and the same sidebar, with the sidebar
 * showing accounting navigation while you are in here.
 *
 * The sidebar decides that for itself from the URL, so nothing needs to be
 * passed down and a refresh or a bookmarked link lands in the right place.
 */
export default function AppContainer({
  title,
  previousPageTitle,
  actions = [],
  children,
  description,
}) {
  const org = useOrgProfile();

  return (
    <div className="page" style={{ overflowY: "auto" }}>
      <Sidebar />

      {/* A column at least as tall as the window, so the footer can be pushed
          to the bottom of it. Without this the footer sat directly under the
          content and left a band of empty page below itself on any short
          page — a list with nothing in it, most obviously. */}
      <div
        className="main-content side-content pt-0"
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <Header />

        <div className="container-fluid" style={{ flex: "1 0 auto" }}>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              {/* Print only: the organisation badge and details above the page
                  content whenever it is sent to a printer. */}
              <PrintLetterhead title={title} subtitle={previousPageTitle} />

              <PageHeader
                title={title}
                previousPageTitle={previousPageTitle}
                actions={actions}
                description={description}
              />

              <div className="col-lg-12">{children}</div>
            </div>
          </div>
        </div>

        <div
          className="main-footer text-center py-3"
          style={{ flex: "0 0 auto", marginTop: "auto" }}
        >
          <div className="container">
            <div className="row row-sm">
              <div className="col-md-12">
                <span>
                  Copyright &copy; {new Date().getFullYear()} &nbsp; Bericot
                  &nbsp;|&nbsp; Accounting &mdash; {org.industryLabel} &nbsp;|
                  All rights reserved.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
